import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap';
import './platesContainer.css';

class PlatesContainer extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <div className={'plates-content'}>
                            <p className={'title'}>Patentes a firmar</p>
                            <p className={'plates'}>
                                { this.props.plates && (this.props.plates).toString().replace(/,/g, ', ')}
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default PlatesContainer;
